const GroupWiseLoanProposalActionTypes = {
	/*************** START ADD GROUP WISE LOAN PROPOSAL ***************/
	ADD_GROUP_WISE_LOAN_PROPOSAL_START: 'ADD_GROUP_WISE_LOAN_PROPOSAL_START',
	ADD_GROUP_WISE_LOAN_PROPOSAL_SUCCESS: 'ADD_GROUP_WISE_LOAN_PROPOSAL_SUCCESS',
	ADD_GROUP_WISE_LOAN_PROPOSAL_FAILURE: 'ADD_GROUP_WISE_LOAN_PROPOSAL_FAILURE',
	ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET: 'ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET',
	ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/*************** END ADD GROUP WISE LOAN PROPOSAL ***************/

	/*************** START UPDATE GROUP WISE LOAN PROPOSAL ***************/
	UPDATE_GROUP_WISE_LOAN_PROPOSAL_START: 'UPDATE_GROUP_WISE_LOAN_PROPOSAL_START',
	UPDATE_GROUP_WISE_LOAN_PROPOSAL_SUCCESS: 'UPDATE_GROUP_WISE_LOAN_PROPOSAL_SUCCESS',
	UPDATE_GROUP_WISE_LOAN_PROPOSAL_FAILURE: 'UPDATE_GROUP_WISE_LOAN_PROPOSAL_FAILURE',
	UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET:
		'UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET',
	UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/*************** END UPDATE GROUP WISE LOAN PROPOSAL ***************/

	GET_SUBGROUP_LIST_START: 'GET_SUBGROUP_LIST_START',
	GET_SUBGROUP_LIST_SUCCESS: 'GET_SUBGROUP_LIST_SUCCESS',
	GET_SUBGROUP_LIST_FAILURE: 'GET_SUBGROUP_LIST_FAILURE',
	GET_SUBGROUP_LIST_RESPONSE_RESET: 'GET_SUBGROUP_LIST_RESPONSE_RESET',
	GET_SUBGROUP_LIST_RESPONSE_CHANGED: 'GET_SUBGROUP_LIST_RESPONSE_CHANGED',
};

export default GroupWiseLoanProposalActionTypes;
